module.exports = __webpack_public_path__ + "static/media/studio-pro-step1.1017f5b1.png";